import { Spin, Button, Affix } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import qs from 'query-string';
import { useRequest } from 'ahooks';
import { isEmpty, isNull } from 'lodash';
import moment from 'moment';
import { getToken } from '@/utils/token';
import FileDownload from '@/components/FileDownload/FileDownload';
import { getDeclarationNoticeDetail } from '@/services/agriculturalSubsidies';
import './index.less';

export default function Detail() {
  const { search } = useLocation();
  const Navigate = useNavigate();

  const { status } = useSelector((state) => state);

  const { data, loading } = useRequest(() => getDeclarationNoticeDetail(qs.parse(search).id));

  function handleChange(item) {
    const token = getToken();
    if (!token) {
      Navigate('/login');
    } else if (status) {
      Navigate('/authentication');
    } else {
      const { id } = item;
      Navigate(`/agriculturalSubsidies/application?id=${id}`, { state: item });
    }
  }

  return (
    <div className="zczx-detail">
      <Spin spinning={loading}>
        <div className="content-width">
          <div className="zczx-detail__title">{data?.title}</div>
          <div>
            &emsp;&emsp;发布时间：
            {data?.gmtCreate}
          </div>
          <div className="zczx-detail__con">
            <div dangerouslySetInnerHTML={{ __html: data?.content }} />
          </div>
          {!isEmpty(data?.specialAgriculturalFileVos) && (
            <div className="zczx-detail_appendix">
              <div style={{ lineHeight: '32px' }}>附件：</div>
              {data?.specialAgriculturalFileVos.map((item) => (
                <FileDownload
                  key={item.id}
                  appendixName={item.fileName}
                  attachmentId={Number(item.id)}
                  url="/special/agricultural/download"
                />
              ))}
            </div>
          )}
          <Affix style={{ marginTop: 20 }} offsetBottom={0}>
            <div style={{ backgroundColor: 'white' }}>
              {
                (isNull(data?.filingDeadline) || (moment().diff(moment(data?.filingDeadline), 'days') <= 0)) && (
                  <Button style={{ marginBottom: 10 }} type="primary" onClick={() => handleChange(data)}>
                    填写申报材料
                  </Button>
                )
              }
              <div className="zczx-detail_bottom-text">
                申报截止日期：
                {isNull(data?.filingDeadline) ? '-' : moment(data?.filingDeadline).format('YYYY-MM-DD')}
              </div>
            </div>
          </Affix>
        </div>
      </Spin>
    </div>
  );
}
